import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import { getEarlyRequest } from 'automation-ui-core/utils/earlyRequesterUtils';
import { ToObjectType, UNKNOWN, UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
const isCrmObjectAccess = access => {
  return access.enrolledType.type === 'CRM_OBJECT';
};
const mapByObjectTypeId = objectTypeAccess => {
  var _objectTypeAccess$enr, _ToObjectType$objectT;
  const objectTypeId = (_objectTypeAccess$enr = objectTypeAccess.enrolledType.objectTypeId) !== null && _objectTypeAccess$enr !== void 0 ? _objectTypeAccess$enr : UNKNOWN_ID;
  return [objectTypeId, {
    accessLevel: objectTypeAccess.accessLevel,
    baselineActionAccessLevel: objectTypeAccess.baselineActionAccessLevel,
    actionTypeAccess: objectTypeAccess.actionTypeAccess,
    objectTypeId,
    flowObjectType: (_ToObjectType$objectT = ToObjectType[objectTypeId]) !== null && _ToObjectType$objectT !== void 0 ? _ToObjectType$objectT : UNKNOWN
  }];
};
function formatObjectTypeAccessResponse(objectTypes) {
  return Object.fromEntries(objectTypes.filter(isCrmObjectAccess).map(mapByObjectTypeId));
}
const earlyRequestName = 'object-type-access';
const sourceAppEarlyRequestName = 'source-app-object-type-access';
export const GET_ACCESS_BY_OBJECT_TYPE_ID = registerQuery({
  fieldName: 'enrollment_accessByObjectTypeId',
  args: ['flowSourceApp'],
  fetcher: ({
    flowSourceApp
  }) => {
    if (flowSourceApp === WORKFLOWS_APP) {
      return getEarlyRequest({
        defaultRequestFn: () => http.get('automationplatform/v1/access/object-enrolled-type-access'),
        key: earlyRequestName
      }).then(formatObjectTypeAccessResponse);
    }
    return getEarlyRequest({
      defaultRequestFn: () => http.get(`automationplatform/v1/access/object-enrolled-type-access?sourceApp=${flowSourceApp}`),
      key: sourceAppEarlyRequestName
    }).then(formatObjectTypeAccessResponse);
  }
});
export const GET_PAYMENT_ELIGIBILITY = registerQuery({
  fieldName: 'paymentEligibility',
  fetcher: () => http.get('payments/v1/payment-accounts/eligibility')
});